import { apiService } from './api';

export interface WhatsAppMessageLog {
    id: string;
    organizationCode: string;
    restaurantId?: string;
    orderId?: string;
    orderNo?: string;
    mobile: string;
    templateName: string;
    mediaUrl?: string;
    status: 'SENT' | 'FAILED';
    providerResponse?: string;
    error?: string;
    trigger: 'SETTLE_AUTO' | 'MANUAL_SHARE';
    createdAt: string;
}

export interface WhatsAppLogsPage {
    content: WhatsAppMessageLog[];
    totalElements: number;
    totalPages: number;
    number: number; // current page index
    size: number;
}

export const whatsappService = {
    async getLogs(
        page = 0,
        size = 20,
        opts?: { org?: string; month?: number; year?: number }
    ): Promise<WhatsAppLogsPage> {
        const params: any = { page, size };
        if (opts?.org) params.org = opts.org;
        if (opts?.month) params.month = opts.month;
        if (opts?.year) params.year = opts.year;
        const response = await apiService.get<WhatsAppLogsPage>('/whatsapp/logs', params);
        return response.data;
    },

    async shareBill(
        orderId: string,
        payload?: { mobile?: string; name?: string }
    ): Promise<{ status: string; mobile?: string; message: string }> {
        const response = await apiService.post<{ status: string; mobile?: string; message: string }>(
            `/whatsapp/share-bill/${orderId}`, payload ?? {});
        return response.data;
    },

    /** Step 1 of enabling WhatsApp — OTP is emailed to the org's registered address. */
    async requestEnableOtp(): Promise<{ message: string; email?: string }> {
        const response = await apiService.post<{ message: string; email?: string }>(
            '/org-settings/whatsapp/request-otp', {});
        return response.data;
    },

    /** Step 2 — verify the OTP; WhatsApp is enabled on success. */
    async verifyEnableOtp(otp: string): Promise<{ whatsappEnabled?: boolean }> {
        const response = await apiService.post<{ whatsappEnabled?: boolean }>(
            '/org-settings/whatsapp/verify-otp', { otp });
        return response.data;
    },
};
